import React from 'react';

import formatPrice from 'Shared/util/formatPrice';
import TableInvoiceDetail from './TableOrderDetail';

const RightPart = ({ data }) => {
  const { lines, total, currency, subject, contactEmail } = data;

  return (
    <div className="tab-invoice-detail__right-part">
      <div className="tab-invoice-detail__paper tab-invoice-detail__table">
        <TableInvoiceDetail invoiceLines={lines} currency={currency} />
      </div>
      <div className="tab-invoice-detail__paper subject_block">
        {total && (
          <div className="total_block">
            <div className="total_block__label">Total amount</div>
            <div className="bank_account total_block__price">
              {formatPrice(total)} {currency}
            </div>
          </div>
        )}
        {subject && (
          <>
            <div className="subject_block__label">Subject</div>
            <div className="subject_block__title">{subject}</div>
            <div className="question_block">
              <div className="question_block__label">
                Any questions? Please let us know{' '}
                <a href={`mailto:${contactEmail}`} className="question_block__link">
                  {contactEmail}
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RightPart;
